import React, { useEffect, useRef } from "react";
import { sentryLogger } from "./SentryLogger";
import { LoggerProvider } from "./useLogger";
/**
 * Bootstrap for the HOST app the micro-apps mount into: builds one `isHost` logger, registers it
 * once and provides it. The host is NEVER unregistered — popping it would hand capture to the wrong
 * app — so there is deliberately no unmount cleanup.
 */
const SentryHostProvider = ({ environment, children }) => {
    const logger = useRef(undefined);
    logger.current ??= sentryLogger(environment, { isHost: true });
    const mounted = useRef(false);
    useEffect(() => {
        // Guarded against StrictMode/double-invoked effects: the host registers once.
        if (mounted.current) {
            return;
        }
        mounted.current = true;
        logger.current?.onMount(undefined);
    }, []);
    return React.createElement(LoggerProvider, { logger: logger.current }, children);
};
export { SentryHostProvider };
